module.exports = __webpack_public_path__ + "static/media/termopary9kz.1eb5203d.pdf";